import type { SurveyQuestion } from '@bandos/shared'
import { OpenQuestion } from './OpenQuestion'
import { ScaleQuestion } from './ScaleQuestion'
import { YesNoQuestion } from './YesNoQuestion'
import { MultipleChoiceQuestion } from './MultipleChoiceQuestion'
import { CheckboxQuestion } from './CheckboxQuestion'

// ─── Answer types ─────────────────────────────────────────────────────────────

export type OpenAnswer = string
export type ScaleAnswer = number | null
export type YesNoAnswer = boolean | null
export type MultipleChoiceAnswer = string | null
export type CheckboxAnswer = string[]

export type SurveyAnswer =
  | OpenAnswer
  | ScaleAnswer
  | YesNoAnswer
  | MultipleChoiceAnswer
  | CheckboxAnswer

// ─── Dispatcher ───────────────────────────────────────────────────────────────

interface SurveyQuestionInputProps {
  question: SurveyQuestion
  value: SurveyAnswer
  onChange: (value: SurveyAnswer) => void
}

export function SurveyQuestionInput({ question, value, onChange }: SurveyQuestionInputProps) {
  switch (question.type) {
    case 'open':
      return (
        <OpenQuestion
          question={question.question}
          value={(value as OpenAnswer | null) ?? ''}
          onChange={onChange}
        />
      )

    case 'scale':
      return (
        <ScaleQuestion
          question={question.question}
          value={value as ScaleAnswer}
          onChange={onChange}
          max={question.scaleMax ?? 5}
        />
      )

    case 'yes_no':
      return (
        <YesNoQuestion
          question={question.question}
          value={value as YesNoAnswer}
          onChange={onChange}
        />
      )

    case 'multiple_choice':
      return (
        <MultipleChoiceQuestion
          question={question.question}
          value={value as MultipleChoiceAnswer}
          options={question.options ?? []}
          onChange={onChange}
        />
      )

    case 'checkbox':
      return (
        <CheckboxQuestion
          question={question.question}
          value={Array.isArray(value) ? value : []}
          options={question.options ?? []}
          onChange={onChange}
        />
      )
  }
}
